// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"SessionEntry_placeholder__PFYG1"};